import React, {Fragment } from 'react';
const SuspenseFallBack = () => {



    return (
        <Fragment>
            <div className="preloader">
                <div className="lds-ripple">
                    <div className="lds-pos"></div>
                    <div className="lds-pos"></div>
                </div>
            </div>

        </Fragment>
    );
}

export default SuspenseFallBack;